<template>
  <div class="am-ap-popup">
    <div>
      <div class="am-ap-title-bar am-main-top-box">
        <span class="am-ap-title am-main-top-box-title"><strong>Additional Premium</strong></span>
      </div>
      <table class="am-ap-table">
        <tbody>
        <tr>
          <td><strong><span>Payee:</span></strong></td>
          <td>
            <select v-model="newAdditionalPremium.selectedPayee" class="am-multi-select">
              <option v-for="payee in payees" :value="payee.value" :key="payee.value">{{payee.name}}</option>
            </select>
        </tr>
        <tr v-if="newAdditionalPremium.selectedPayee === 'carrier' && policyItems.length > 1">
          <td><strong><span>Policies Financed:</span><span class="am-additional-premium-required">&nbsp;&nbsp;*</span></strong></td>
          <td>
            <select multiple size="5" class="am-multi-select-options-box" v-model="newAdditionalPremium.selectedPolicies" @click="resetDownPayment">
              <option v-for="policyItem in policyItems" :value="policyItem.id" :key="policyItem.id">{{policyItem.policy}} - {{policyItem.product.company.name}} </option>
            </select>
        </tr>
        <tr>
          <td><strong><span>Payment Only:</span></strong></td>
          <td class="am-switch-payment-only"><yes-no-switch v-model="paymentOnly"></yes-no-switch></td>
        </tr>
        <tr v-if="!paymentOnly">
          <td><strong><span>Date Changed:</span></strong></td>
          <td>
            <input type="date" class="input am-ap-date" v-model="newAdditionalPremium.dateFinanced">
          </td>
        </tr>
        <tr v-if="!paymentOnly">
          <td><strong><span>Additional Premium:</span></strong></td>
          <td>
            <money type="text" class="input" v-model="newAdditionalPremium.additionalPremium" v-bind="money"/>
          </td>
        </tr><tr v-if="!paymentOnly">
          <td><strong><span>Policy Fee:</span></strong></td>
          <td>
            <money type="text" class="input" v-model="newAdditionalPremium.policyFee" v-bind="money"/>
          </td>
        </tr>
        <tr v-if="!paymentOnly">
          <td><strong><span>Tax:</span></strong></td>
          <td>
            <money type="text" class="input" v-model="newAdditionalPremium.tax" v-bind="money"/>
          </td>
        </tr>
        <tr v-if="!paymentOnly">
          <td><strong><span>MGA Fee:</span></strong></td>
          <td>
            <money type="text" class="input" v-model="newAdditionalPremium.mgaFee" v-bind="money"/>
          </td>
        </tr>
        <tr v-if="!paymentOnly">
          <td><strong><span>Amount Financed:</span></strong></td>
          <td>
            <money type="text" class="input" v-model="newAdditionalPremium.amount" v-bind="money"/>
          </td>
        </tr>
        <tr v-if="newAdditionalPremium.selectedPolicies.length < 2 || newAdditionalPremium.selectedPayee === 'premiumFinanceCompany' || (newAdditionalPremium.selectedPayee === 'carrier' && policyItems.length === 1)">
          <td><strong><span>Down Payment:</span></strong></td>
          <td>
            <money type="text" class="input" v-model.lazy="newAdditionalPremium.downPayment" v-bind="money"/>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="am-blue-border"></div>
      <div class="am-ap-align-bottom-buttons">
        <div class="am-ap-float-right">
          <button type="button" class="btn btn-primary" @click="submit" :disabled="(policyItems.length > 1 && newAdditionalPremium.selectedPolicies.length < 1 && newAdditionalPremium.selectedPayee === 'carrier')">Submit</button>
          <button type="button" class="btn btn-secondary" @click="closeModal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { Money, VMoney } from 'v-money'
    import api from './../http'
    export default {
        name: "Additional Premium",
        data () {
            return {
                newAdditionalPremium: {
                    selectedPayee: 'carrier',
                    policyFee: 0,
                    tax: 0,
                    mgaFee:0,
                    amount: 0,
                    downPayment: 0,
                    dateFinanced: this.financeRecord.dateFinanced.substr(0,10),
                    selectedPolicies: []
                },
                money: {
                    decimal: '.',
                    thousands: ',',
                    prefix: '$ ',
                    masked: false
                },
                payees: [
                    {
                        value: 'carrier',
                        name: 'Carrier'
                    },
                    {
                        value: 'premiumFinanceCompany',
                        name: 'Premium Finance Company'
                    }
                ],
                policyItems: [
                    {
                        policy: 0,
                        product: {
                            id: 0,
                            policy_type: {
                                name: ''
                            },
                            company: {
                                name: ''
                            }
                        },
                        status: '',
                        premium: 0,
                        effdate: '',
                        expdate: ''
                    }
                ],
                paymentOnly: 0,

            }
        },
        directives: {
            money: VMoney
        },

        mounted () {
            this.newAdditionalPremium.premiumFinanceId = this.financeId;
            let self = this
            api.makeRequest('/customer/finance/' + this.financeId + '/policies').then(
                (data) => {
                    self.policyItems = data.data.results
                }
            )
        },

        methods: {
            closeModal() {
                this.$modal.hide('apDialog')
            },
            submit () {
                let self = this
                let emptyFees = self.validateFees(self.newAdditionalPremium)
                if(emptyFees === false){
                    api.postRequest('customer/finance/additional-premium/save', self.newAdditionalPremium).then(
                        (data) => {
                            if (self.newAdditionalPremium.downPayment > 0 || self.newAdditionalPremium.selectedPayee === 'carrier') {
                                //self.closeModal()
                                self.addCustomerPayment()
                            }
                            self.closeModal()
                        }
                    ).catch(
                        (error) => {
                            self.closeModal()
                            if (self.paymentOnly === 1){
                                self.addCustomerPayment()
                            }
                        })
                } else {
                    if (self.newAdditionalPremium.downPayment > 0 || self.paymentOnly === 1 || self.newAdditionalPremium.selectedPayee === 'carrier') {
                        self.closeModal()
                        self.addCustomerPayment()
                    } else {
                        self.closeModal()
                    }
                }
            },
            getPolicyIds() {
                let ids = '';
                this.newAdditionalPremium.selectedPolicies.forEach(policy => {
                    ids = policy + ',' + ids
                })
                return ids.slice(0,ids.length-1);
            },
            formatCurrency(value) {
                let val = (value/1).toFixed(2).replace(',', '.')
                return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "")
            },
            validateFees(additionalPremiumFees) {
              let validateAdditionalPremium =  (additionalPremiumFees.additionalPremium === 0 || typeof(additionalPremiumFees.additionalPremium) === 'undefined')
              let emptyAdditionalPremiumFees = validateAdditionalPremium  && additionalPremiumFees.policyFee === 0 && additionalPremiumFees.mgaFee === 0 && additionalPremiumFees.amount === 0 && additionalPremiumFees.tax === 0
              return (emptyAdditionalPremiumFees && additionalPremiumFees.downPayment > 0)
            },
            addCustomerPayment() {
                let self = this
                let policyIds = (self.newAdditionalPremium.selectedPayee === 'carrier' && self.policyItems.length > 1) ? self.getPolicyIds() : self.policyItems[0].id.toString()
                let saveDownPayment = self.newAdditionalPremium.selectedPayee === 'carrier'
                let fundingStatus = self.fundingStatus === "Partial Funded" ? "APP" : "APF"
                let financeAmount = (policyIds.search(",") === -1) ? self.formatCurrency(self.newAdditionalPremium.downPayment) : self.formatCurrency(0)
                window.location.href = '/customersPayment.php?id=' + self.policyItems[0].custid + '&items=' + policyIds + '&financeAmount=' + financeAmount + '&saveDownPayment=' + saveDownPayment + '&isAdditionalPremium=true&isPremiumFinance=true&paymentAppendage=' + fundingStatus
            },
             resetFees() {
               if (this.paymentOnly){
                 let additionalPremiumFees = this.newAdditionalPremium
                 additionalPremiumFees.policyFee = 0
                 additionalPremiumFees.mgaFee = 0
                 additionalPremiumFees.amount = 0
                 additionalPremiumFees.tax = 0
                 additionalPremiumFees.additionalPremium = 0
               }
             },
            resetDownPayment() {
                let additionalPremium = this.newAdditionalPremium
                if (additionalPremium.selectedPolicies.length !== 1 && additionalPremium.selectedPayee === 'carrier'){
                    additionalPremium.downPayment = 0
                }
            }
        },
        components: {
            Money
        },
        props: {
            financeId: Number,
            financeRecord: {
              type: Object,
              default: null
            },
            fundingStatus: String
        },
      watch: {
        'paymentOnly': {
          handler: function () {
            this.resetFees()
          }
        }
      }
    }
</script>
<style scoped>

  .am-main-top-box {
    padding: 8px;
  }
  .am-main-top-box-title {
    font-size: 12px;
  }
  .am-ap-table {
    margin-top: 10px;
    margin-left: 12px;
  }
  .am-ap-date {
    width: 160px;
    height: 22px;
  }
  .am-ap-table td input {
    margin: 1px 0 0 30px;
    background-color: white;
    width: 160px;
  }

  .am-blue-border {
    display: block;
    width: 100%;
    border-top: 1px solid #4297d7;
    margin-top: 20px;
  }
  .btn-primary {
    padding: 4px 12px;
    font-size: 12px;
    margin-right: 3px;
  }
  .btn-secondary {
    padding: 4px 12px;
    font-size: 12px;
    margin-right: 3px;
  }
  .am-ap-align-bottom-buttons {
    float: right;
    padding: 10px;
    margin-right: 10px;
  }

  .am-multi-select {
    margin: 1px 0 0 30px;
    background-color: white;
  }

  .am-multi-select-options-box {
    height: 100%;
    overflow: scroll;
    margin: 1px 0 0 30px;
    background-color: white;
    max-width: 220px;
  }

  .am-switch-payment-only {
    padding-left: 30px;
    padding-top: 2px;
  }

  .am-additional-premium-required{
    color: red;
  }
</style>
